import { ElementDetails } from "@/lib/types";

export const details = {
  name: "Grid",
  description: "Full-screen grid layout",
  category: "Layout",
  grid: {},
  defaultProps: {},
} as ElementDetails;
